<template lang="html">

  <article class="proyecto-el">

    <div class="row-center ais">
      <div class="contenedor-info column-start">

        <h2>{{project.country}} {{project.start_year}}</h2>

        <h3>{{project.name}}</h3>

        <p>{{project.description}}</p>

        <p class="personas">Ayuda a <strong>{{project.persons_helped}}</strong> Personas</p>

        <div class="financiado -mvl" v-if="percent != null">
          <h2>
            <strong>{{percent}}%</strong>
            Financiado
          </h2>
          <div class="contenedor-gota">
            <gota :red="true" :height="62" :width="40" :percent="percent"></gota>
          </div>

        </div>

        <router-link class="btn with-border" :to="$t('enlaces.proyecto')+'/'+project.slug">Ver proyecto</router-link>

      </div>
      <div class="contenedor-imagen" :style="`background:url(${project.image.url}) center/cover no-repeat`"></div>
      <div class="contenedor-financiacion column-center">
        <img src="/static/img/pozo-financiacion.svg" alt="imagen pozo financiero">
        <div class="financiado" v-if="percent != null">
          <h2>
            <strong>{{percent}}%</strong>
            Financiado
          </h2>
          <div class="contenedor-gota">
            <gota :height="62" :width="40" :percent="percent"></gota>
          </div>

        </div>
        <router-link v-if="project.complete == 0" :to="$t('enlaces.proyecto')+'/'+project.slug+'#donar'" class="btn red">Donar</router-link>

      </div>
    </div>


  </article>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  import gota from '@/components/parts/gota';


  export default {
    name: 'proyecto-el',
    props: ['project'],
    data() {
      return {
        showpopup: false,
      }
    },
    computed: {
      percent() {
        if(this.project.complete === 1) {
          return 100;
        }
        /* return (100 * this.project.total / this.project.money_needed).toFixed(2); */
        return this.project.per;
      }
    },
    methods: {
      ...mapActions(['setProjectToPay']),
    },
    components : {
      'gota' : gota
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/parts/proyecto.vue